"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var initState = {
    client: {
        email: '',
        name: '',
        phone: '',
        photo: '',
        facebook_id: '',
        facebook_friends_ids: [],
        chain_id: null,
        birthdate: null,
    },
    token: null,
    loading: false
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case actions_1.FETCH_USER_DENIED:
            return initState;
        case actions_1.FETCH_USER_SUCCESS:
            return __assign(__assign({}, state), { client: __assign(__assign({}, state.client), action.data) });
        case actions_1.LOGIN_REQUEST:
        case actions_1.LOGOUT_REQUEST:
        case actions_1.GET_CODE_REQUEST:
            return __assign(__assign({}, state), { loading: true });
        case actions_1.LOGIN_SUCCESS:
            return __assign(__assign({}, state), { loading: false, client: action.client, token: action.token });
        case actions_1.GET_CODE_SUCCESS:
            return __assign(__assign({}, state), { loading: false });
        case actions_1.LOGIN_FAILURE:
        case actions_1.GET_CODE_FAILURE:
            return __assign(__assign({}, state), { loading: false });
    }
    return state;
});
